import { years, months } from './constant'
import { accountList } from './account'

export const functionList = [
    {
        title: '所有函数',
        expand: true,
        children: [
            {
                title: '基础函数',
                expand: true,
                children: [
                    {
                        title: '绝对值',
                        name: 'ABS',
                        desription: '返回给定数值的绝对值',
                        params: [
                            {
                                title: '数值',
                                dataType: 'number',
                                rules: [{required: true, message: '此项不能为空' }],
                                control: {
                                    type: 'input',
                                    inputType: 'text'
                                }
                            }
                        ]
                    },
                    {
                        title: '求和',
                        name: 'SUM',
                        desription: '返回某一单元格区域中所有数值的和',
                        params: [
                            {
                                title: '数组',
                                dataType: 'Array<number>',
                                rules: [{required: true, message: '此项不能为空' }],
                                control: {
                                    type: 'input',
                                    inputType: 'text'
                                }
                            }
                        ]
                    },
                    {
                        title: '条件判断',
                        name: 'IF',
                        desription: '根据条件返回指定的值',
                        params: [
                            {
                                title: '条件',
                                dataType: 'boolean',
                                rules: [{required: true, message: '此项不能为空' }],
                                control: {
                                    type: 'input',
                                    inputType: 'text'
                                }
                            },
                            {
                                title: '真返回值',
                                dataType: 'any',
                                rules: [{required: true, message: '此项不能为空' }],
                                control: {
                                    type: 'input',
                                    inputType: 'text'
                                }
                            },
                            {
                                title: '否返回值',
                                dataType: 'any',
                                rules: [{required: true, message: '此项不能为空' }],
                                control: {
                                    type: 'input',
                                    inputType: 'text'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                title: '财务函数',
                expand: true,
                children: [
                    {
                        title: '累计发生额',
                        name: 'LJFSE',
                        desription: '返回某一会计科目的累计发生额',
                        params: [
                            {
                                title: '会计科目一',
                                dataType: 'string',
                                rules: [{required: true, message: '此项不能为空' }],
                                control: {
                                    type: 'TseTreeSelect',
                                    options: accountList
                                }
                            },
                            {
                                title: '会计科目二',
                                dataType: 'string',
                                rules: [{required: true, message: '此项不能为空' }],
                                control: {
                                    type: 'TseTreeSelect',
                                    options: accountList
                                }
                            },
                            {
                                title: '年度',
                                dataType: 'number',
                                rules: [{required: true, message: '此项不能为空' }],
                                control: {
                                    type: 'select',
                                    selectList: years
                                }
                            },
                            {
                                title: '截止期间',
                                dataType: 'number',
                                control: {
                                    type: 'select',
                                    selectList: months
                                }
                            }
                        ],
                        calc: (accountCode1, accountCode2, year, period) => {
                            console.log(accountCode1, accountCode2, year, period)
                            return 0
                        }
                    },
                    {
                        title: '发生额',
                        name: 'FSE',
                        desription: '返回某一会计科目的当期发生额',
                        params: [
                            {
                                title: '会计科目',
                                dataType: 'string',
                                rules: [{required: true, message: '此项不能为空' }],
                                control: {
                                    type: 'TseTreeSelect',
                                    options: accountList
                                }
                            },
                            {
                                title: '年度',
                                dataType: 'number',
                                rules: [{required: true, message: '此项不能为空' }],
                                control: {
                                    type: 'select',
                                    selectList: years
                                }
                            },
                            {
                                title: '截止期间',
                                dataType: 'number',
                                control: {
                                    type: 'select',
                                    selectList: months
                                }
                            }
                        ],
                        calc: (accountCode, year, period) => {
                            console.log(accountCode, year, period)
                            return 0
                        }
                    }
                ]
            },
            {
                title: '会计报表函数',
                expand: true,
                children: [
                    {
                        title: '资产负债表',
                        name: 'ZCFZB',
                        desription: '返回资产负债表中某一项的值',
                        params: [
                            {
                                title: '项目编号',
                                dataType: 'string',
                                rules: [{required: true, message: '此项不能为空' }],
                                control: {
                                    type: 'select',
                                    selectList: [
                                        {
                                            value: '0001',
                                            label: '损益项目一'
                                        },
                                        {
                                            value: '0002',
                                            label: '损益项目二'
                                        },
                                    ]
                                }
                            },
                            {
                                title: '年度',
                                dataType: 'number',
                                rules: [{required: true, message: '此项不能为空' }],
                                control: {
                                    type: 'select',
                                    selectList: years
                                }
                            },
                            {
                                title: '截止期间',
                                dataType: 'number',
                                control: {
                                    type: 'select',
                                    selectList: months
                                }
                            }
                        ],
                        calc: (itemNo, year, period) => {
                            console.log(itemNo, year, period)
                            return 0
                        }
                    },
                    {
                        title: '损益表',
                        name: 'SYB',
                        desription: '返回损益表中某一项的值',
                        params: [
                            {
                                title: '项目编号',
                                dataType: 'string',
                                rules: [{required: true, message: '此项不能为空' }],
                                control: {
                                    type: 'select',
                                    selectList: [
                                        {
                                            value: '0001',
                                            label: '损益项目一'
                                        },
                                        {
                                            value: '0002',
                                            label: '损益项目二'
                                        },
                                    ]
                                }
                            },
                            {
                                title: '年度',
                                dataType: 'number',
                                rules: [{required: true, message: '此项不能为空' }],
                                control: {
                                    type: 'select',
                                    selectList: years
                                }
                            },
                            {
                                title: '截止期间',
                                dataType: 'number',
                                control: {
                                    type: 'select',
                                    selectList: months
                                }
                            }
                        ],
                        calc: (itemNo, year, period) => {
                            console.log(itemNo, year, period)
                            return 0
                        }
                    }
                ]
            },
            {
                title: '其他函数',
                expand: true,
                children: [
                    {
                        title: '其他函数一',
                        name: 'QT1',
                        desription: '返回其它的值',
                        params: [

                        ],
                        calc: () => {
                            return '其他函数一'
                        }
                    },
                    {
                        title: '其他函数二',
                        name: 'QT2',
                        desription: '返回其它的值',
                        params: [

                        ],
                        calc: () => {
                            return '其他函数二'
                        }
                    },
                    {
                        title: '其他函数三',
                        name: 'QT3',
                        desription: '返回其它的值',
                        params: [

                        ],
                        calc: () => {
                            return '其他函数三'
                        }
                    },
                    {
                        title: '其他函数四',
                        name: 'QT4',
                        desription: '返回其它的值',
                        params: [

                        ],
                        calc: () => {
                            return '其他函数四'
                        }
                    },
                ]
            }
        ]
    }
]